import { useQuery } from "@tanstack/react-query";
import useUserStore from "@/modules/users/store";
import { getProjetosByEmbaixadorPessoa } from "../firestore";

const useGetProjetosByEmbaixador = (embaixadorPessoaId: string | undefined) => {
  const activeEmpresaId = useUserStore((state) => state.activeEmpresaId);

  return useQuery({
    queryKey: ["projetos-by-embaixador", activeEmpresaId, embaixadorPessoaId],
    queryFn: () => {
      if (!activeEmpresaId || !embaixadorPessoaId) {
        return Promise.resolve([]);
      }
      return getProjetosByEmbaixadorPessoa(activeEmpresaId, embaixadorPessoaId);
    },
    enabled: !!activeEmpresaId && !!embaixadorPessoaId
  });
};

export default useGetProjetosByEmbaixador;
